import request from "@/utils/request";
export function index(params) {
    return request({
        url: "/officers",
        method: "get",
        params,
    });
}
export function update(id, data) {
    return request({
        url: "/officers/" + id,
        method: "put",
        data,
    });
}
export function show(id) {
    return request({
        url: "/officers/" + id,
        method: "get",
    });
}
export function store(data) {
    return request({
        url: "/officers",
        method: "post",
        data,
    });
}
export function destroy(id) {
    return request({
        url: "/officers/" + id,
        method: "delete",
    });
}

export function getOfficersFromExamination(params) {
    return request({
        url: "/officers-by-examination",
        method: "get",
        params,
    });
}
export function getExaminationSubjectsByOfficer(params) {
    return request({
        url: "/examination-subjects-by-officer",
        method: "get",
        params,
    });
}
export function addOfficersToExamination(data) {
    return request({
        url: "/officers-by-examination",
        method: "post",
        data,
    });
}
